import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import item from './item.js'

export default contract({
  item: array([
    item
  ])
})
